import React from 'react';
import {Link} from "react-router-dom";
import './LinkCell3.sass'
import pencilSVG from './pencil.svg'
import PropTypes from "prop-types";

LinkCell.propTypes = {
    linkRoute: PropTypes.string,
    linkTitle: PropTypes.any,
    editClick: PropTypes.any
}

function LinkCell(props) {
    return (
        <>
            <div key={props.linkTitle + props.linkRoute} className='row__cell LinkCell'>
                {props.linkRoute
                    ? <Link title={props.linkTitle} to={props.linkRoute}>{props.linkTitle}</Link>
                    : <a title={props.linkTitle} href={null}> {props.linkTitle}</a>
                }
            </div>
            {props.editClick
                ? <div onClick={props.editClick} className="editButton">
                    <img src={pencilSVG} alt="open"/></div>
                : ''}
        </>

    );
}

export default LinkCell;